export default __webpack_public_path__ + "static/media/search.2d8db0c0.svg";